function n(...n){return t=>{n.forEach((n=>{"function"==typeof n?n(t):null!=n&&(n.current=t)}))}}export{n as default,n as useCombineRefs};
